import { TitleText } from '@/components/TitleText';
import { BodyText } from '@/components/BodyText';
import { Box, Button } from '@mui/material';
import { Extension, Description, AccountTree } from '@mui/icons-material';
import { AiTwotoneFolderOpen } from 'react-icons/ai';
import { styled, useTheme } from '@mui/material/styles';
import { useSearchParams } from 'react-router-dom';
import { SHOW_HELP_PARAM, HELP_VIEW_PARAM, HELP_SECTION_PARAM } from '@/components/HelpContent/helpParameters';
import { HelpSection } from '@/components/HelpContent/HelpContent';
import { UploadView } from '@/components/HelpContent/AssetsUploadView';
import { AssetsPageObjectModel } from '@/poms/assetsPageObjectModel';
import { ZeroStateContainer } from './ZeroStateContainer';

const ActionButton = styled(Button)(({ theme }) => ({
  flex: 1,
  padding: '12px 16px',
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: '8px',
  borderColor: theme.palette.divider,
  width: '70%',
}));

const UploadContainer = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: '16px',
  padding: '32px',
  textAlign: 'center',
  maxWidth: '500px',
  width: '100%',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  backgroundColor: theme.palette.background.paper,
}));

export const ZeroStateUpload = () => {
  const [, setSearchParameters] = useSearchParams();

  const handleFileTypeClick = () => {
    setSearchParameters(
      previous => {
        const newParameters = new URLSearchParams(previous);
        newParameters.set(SHOW_HELP_PARAM, '1');
        newParameters.set(HELP_SECTION_PARAM, HelpSection.Upload);
        newParameters.set(HELP_VIEW_PARAM, UploadView.FileTypes);
        return newParameters;
      },
      { replace: true }
    );
  };

  const handleFilesClick = () => {
    setSearchParameters(
      previous => {
        const newParameters = new URLSearchParams(previous);
        newParameters.set(SHOW_HELP_PARAM, '1');
        newParameters.set(HELP_SECTION_PARAM, HelpSection.Upload);
        newParameters.set(HELP_VIEW_PARAM, UploadView.HowToUpload);
        return newParameters;
      },
      { replace: true }
    );
  };

  const handleAssemblyClick = () => {
    setSearchParameters(
      previous => {
        const newParameters = new URLSearchParams(previous);
        newParameters.set(SHOW_HELP_PARAM, '1');
        newParameters.set(HELP_SECTION_PARAM, HelpSection.Upload);
        newParameters.set(HELP_VIEW_PARAM, UploadView.AssemblyGuidelines);
        return newParameters;
      },
      { replace: true }
    );
  };

  const theme = useTheme();

  return (
    <ZeroStateContainer data-testid={AssetsPageObjectModel.ZeroStateUpload}>
      <UploadContainer>
        <Box>
          <AiTwotoneFolderOpen size={80} color={theme.palette.text.primary} />
        </Box>
        <TitleText sx={{ marginBottom: '8px' }}>Get started by uploading your first asset</TitleText>
        <BodyText color='text.secondary'>Drop files here to begin</BodyText>

        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            marginTop: '24px',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <ActionButton onClick={handleFileTypeClick} variant='outlined' startIcon={<Extension />}>
            Supported formats
          </ActionButton>

          <ActionButton onClick={handleFilesClick} variant='outlined' startIcon={<Description />}>
            File guidelines
          </ActionButton>

          <ActionButton onClick={handleAssemblyClick} variant='outlined' startIcon={<AccountTree />}>
            Assembly files
          </ActionButton>
        </Box>
      </UploadContainer>
    </ZeroStateContainer>
  );
};
